/* eslint-disable arrow-parens */
import testsApi from '@/api/tests';

// initial state
const testState = {
  test: null,
  student: null,
  testSubmitted: false,
};

// getters
const getters = {
  test: (currentState) => currentState.test,
  students: (currentState) => currentState.test.students,
  otherStudents: (currentState) =>
    currentState.test.students
      .filter((s) => s.student.id !== currentState.student.id)
      .map((s) => s.student),
  student: (currentState) => currentState.student,
  testSubmitted: (currentState) => currentState.testSubmitted,
};

// actions
const actions = {
  selectStudent({ commit }, student) {
    commit('selectStudent', student);
  },
  refreshTest({ dispatch, commit, state }) {
    dispatch('showLoader');
    commit('setTestNotSubmitted');
    testsApi.getTest(state.test.code).then((response) => {
      commit('selectTest', response.data);
      dispatch('hideLoader');
    });
  },
  getTest({ dispatch, commit }, code) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      testsApi.getTest(code).then(
        (response) => {
          dispatch('hideLoader');
          resolve(response);
          commit('selectTest', response.data);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  submitTest({ dispatch, commit }, result) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      testsApi.submitTest(result).then(
        (response) => {
          commit('setTestSubmitted');
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
};

// mutations
const mutations = {
  selectTest(currentState, test) {
    currentState.test = test;
  },
  selectStudent(currentState, student) {
    currentState.student = student;
  },
  setTestSubmitted(currentState) {
    currentState.testSubmitted = true;
  },
  setTestNotSubmitted(currentState) {
    currentState.testSubmitted = false;
  },
};

export default {
  state: testState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/tests.js